"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.Validator = void 0;
var factory_1 = require("./factory");
var validation_1 = require("./validation");
var defaultValidateOptions = { removeValid: true };
var Validator = (function () {
    function Validator() {
    }
    Validator.prototype.validateField = function (obj, field, fieldValidators) {
        return __awaiter(this, void 0, void 0, function () {
            var validations, errors, warnings, valid;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, Promise.all(fieldValidators.map(function (fieldValidator) { return fieldValidator(field, obj); }))];
                    case 1:
                        validations = _a.sent();
                        errors = [];
                        warnings = [];
                        validations.forEach(function (validationResult) {
                            if (!validationResult.valid) {
                                var arr = validationResult.severity === validation_1.ValidationSeverity.error ? errors : warnings;
                                arr.push(validationResult);
                            }
                        });
                        valid = errors.length === 0 && warnings.length === 0;
                        return [2, factory_1.ValidationFactory.createInstance({ valid: valid, errors: errors, warnings: warnings })];
                }
            });
        });
    };
    Validator.prototype.validate = function (obj, fieldsValidators, options) {
        if (options === void 0) { options = defaultValidateOptions; }
        return __awaiter(this, void 0, void 0, function () {
            var fieldsValidationArray, fields, valid;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, Promise.all(Object.entries(fieldsValidators).flatMap(function (_a) {
                            var field = _a[0], fieldValidators = _a[1];
                            return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_b) {
                                return [2, this.validateField(obj, field, fieldValidators)];
                            }); });
                        }))];
                    case 1:
                        fieldsValidationArray = _a.sent();
                        fields = {};
                        valid = true;
                        Object.keys(fieldsValidators).forEach(function (field, index) {
                            var fieldValidation = fieldsValidationArray[index];
                            if (!options.removeValid || !fieldValidation.valid) {
                                fields[field] = fieldValidation;
                                valid = false;
                            }
                        });
                        return [2, factory_1.ValidationFactory.createInstance({ valid: valid, fields: fields })];
                }
            });
        });
    };
    return Validator;
}());
exports.Validator = Validator;
//# sourceMappingURL=validator.js.map